import { Box, Divider, Drawer, Grid, List, ListItem, ListItemText, TextField, Typography } from "@material-ui/core";
import styled from "styled-components";
import { ReactComponent as EditIcon } from 'icons/edit-settings-icon.svg'
import { ReactComponent as SecurityIcon } from 'icons/security.svg'
import { ReactComponent as FilterIcon } from 'icons/filter-settings.svg'
import { AccountSettingsGroupItemName } from "models/account-settings/account-settings.store";
import { darken } from "polished";
import { KeyboardArrowDown } from '@material-ui/icons'
import { ReactComponent as DrawerOpenIcon } from 'icons/down-open-icon.svg'
import { ReactComponent as DrawerClosedIcon } from 'icons/down-closed-icon.svg'
import { CustomListItem } from "./components/edit-member-profile/EditProfileDrawer";
import { Select } from "common/molecules/Select/Select";
import { InputFieldGroup } from "common/molecules/InputFieldGroup/InputFieldGroup";

export const StyledDrawer = styled(Drawer)<{isDevice?: boolean}>`
&& {
    .MuiDrawer-paper {
        display: block;
        background-color: ${props => props.theme.colors.supplementary};
        top: ${props => props.isDevice ? '7rem' : 0};
        min-width: ${props => props.isDevice ? '94%' : '288px'}; 
        height: ${props => props.isDevice ?  '651px' : '500px'};
        position: absolute;
        border-radius: ${props => props.isDevice ? '12px' : '24px'};
        margin-left: ${props => props.isDevice ? '12px' : `calc(100% - 44rem)`};
    }
}
`
export const StyledAccountSettingsBox = styled(Box)`
&& {
    color: ${props => props.theme.colors.accent1};
    font-family: Montserrat;
    padding: 17px 24px 18px 20px;
}
`

export const StyledLineDiv = styled.div `
    width: 288;
    height: 0; 
    border: 2px ${props => props.theme.colors.bgPrimary} solid;

`
export const StyledEditIcon = styled(EditIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`

export const StyledSecurityIcon = styled(SecurityIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`
export const StyledFilterIcon = styled(FilterIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`
export const StyledDrawerOpenIcon = styled(DrawerOpenIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`
export const StyledDrawerClosedIcon = styled(DrawerClosedIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`

export const StyledListItem = styled(ListItem)<{selectedItem: AccountSettingsGroupItemName, groupName: AccountSettingsGroupItemName, isDevice: boolean  }>`
  && {
    background-color: ${props => ((!props.isDevice && props.selectedItem) === props.groupName) ? props.theme.colors.supplementary1 : null};
    color: ${props => ((!props.isDevice && props.selectedItem) === props.groupName) ? props.theme.colors.secondary : props.theme.colors.accent1};
    padding: 12px 88px 12px 20px;
    border-radius: ${props => ((!props.isDevice && props.selectedItem) === props.groupName) ? '16px' : null};
    width: 264px;
    .MuiTypography-subtitle1 {
        font-family: Montserrat;
        margin-left: 16px;
    }
    .MuiListItemIcon-root {
        min-width: 16px;
    }
    margin-left: ${props => props.isDevice ? '26px' : '12px'};

    :hover {
      background-color: ${props => (props.theme.colors.supplementary1)};
      color: ${props => (props.theme.colors.secondary)};
      border-radius: 16px;
    }
  }
`

export const StyledListItemText = styled(ListItemText)`
  && .MuiTypography-h6 {
        color: ${props => props.theme.colors.accent1}; 
        margin-left: 24px;  
        font-family: Montserrat;  
    }
`

export const StyledContainer = styled(Box)<{isDevice: boolean}>`
  border-radius: 0px 0px 24px 24px;
  && .MuiFormControl-root {
    width: ${props => props.isDevice ? '100%' : props.width || '808px'}
  }
`

export const StyledTextField = styled(InputFieldGroup)`
  && .MuiInputBase-root {
    border: none;
    border-radius: 30px;
  }
`
export const StyledSelect = styled(Select)`
  margin-top: 0.5rem;
  && .MuiInputBase-root {
    color: ${props => props.theme.colors.accent1};
    border: none;
    border-radius: 30px;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
  }
  
`
export const StyledLocationSelect = styled(Select)`
  && .MuiInputBase-root {
    color: ${props => props.theme.colors.accent1};
    border: none;
    border-radius: 30px;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
  }
  
`
export const StyledTextFieldSelect = styled(TextField)<{isDevice: boolean}>`
  && .MuiInputBase-root {
    background-color: ${props => props.theme.colors.bgPrimary};
    color: ${props => props.theme.colors.accent1};
    border: none;
    border-radius: 30px;
    width: ${props => props.isDevice ? '100%' : '33%'};
  }
  && .MuiOutlinedInput-notchedOutline {
    border: none;
    }
  & .MuiInputBase-root.Mui-disabled {
    color: ${props => darken(0.35, props.theme.colors.accent)} !important;
  }

  && .MuiFormHelperText-root {
    color: ${props => props.theme.colors.accent1} !important;
    font-weight: 400;
    font-size: '0.75rem';
  }
`
export const StyledDropDown = styled(KeyboardArrowDown)`
  && {
    color: ${props => props.theme.colors.primary};
    margin-right: 6px;
    cursor: pointer;
    rotate: '180deg';
  }
`

export const StyledLabel = styled(Typography)`
 && {
    margin-bottom: 1rem
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
 }
`
export const UpdateButtonContainer = styled(Box)`
  display: flex;
  width: 100%;
  padding: 0px 16px;
  justify-content: flex-end;
  align-items: center;  
  margin-top: 1.9rem;
  margin-bottom: 1.5rem;
`
export const UpdateMainGoalsBox = styled(Box)<{isDevice: boolean}>`
  display: flex;
  gap: 0 10px;
  align-items: end;
  justify-content: end;
  margin-right: 1rem;
  margin-bottom: 1.9rem;
`

export const StyledInputBox = styled(Box)`
  && {
      display: flex;
    paddingLeft: 2;
    color: ${props => props.theme.colors.accent1};
  }
`

export const StyledAccountSettingsContainer = styled(Box)`
  max-width: 80em;
  margin: 1rem auto;
  display: flex;
  justify-content: space-around;
  height: 100vh
`
export const StyledAccountSettingsWrapper = styled(Box)`
    display: flex;
    justify-content: space-around;
`

export const StyledAccountSettingsSideNavWrapper = styled(Box)`
    position: fixed;
    width: 8vw;
`
export const StyledAccountSettingsChildrenWrapper = styled(Box)`
   && {
       margin-left: 22em;
       overflow-y: auto;
       width: 909px;
       ::-webkit-scrollbar {
        width: 0.43em;
        background-color: transparent;
      }
      ::-webkit-scrollbar-corner{
        color: transparent;
      }
   } 
`
export const StyledEditProfileWrapper = styled(Box)<{isDevice: boolean}>`
&& {   
        display: block;
        min-width: 94%; 
        overFlow-y: scroll;
        min-height: auto;
        max-height: ${props => props.isDevice ? '73vh' : 'auto'};
        position: absolute;
        border-radius: 12px;
        margin-left: 12px;
}
`
export const StyledDrawerList = styled(List)<{isDevice: boolean}>`
    && {
        width: ${props => props.isDevice ? '92vw' : ''};
    }    
`
export const StyledDivider = styled(Divider)<{isDevice: boolean}>`
    && {
            width: ${props => props.isDevice ? '' : '100%'};
            height: 4px;
            background-color: none;
            border: ${props => !props.isDevice && `2px ${props => props.theme.colors.supplementary} solid`}; 
    }    
`
export const StyledGridLocationWraper = styled(Grid)<{isDevice: boolean}>`
    && {
        max-width: ${props => props.isDevice ? '100vw' : '816px'}
    }
`
export const StyledListComponent = styled(List)`
    && {
      background: ${props => props.theme.colors.supplementary}; 
      border-radius: 0px 0px 24px 24px;
      bottom: 12px;
    }
`